export const saveRequestForm = (serializedData) => {
    return new Promise((resolve, reject) => {
        $.post('/Operations/DownstreamContract/SaveDownstreamContractRequest', serializedData, function (response) {
            if (response.success) {
                $('[name="Id"]').val(response.id);

                resolve(response.message);
            } else {
                reject("Failed to Save Form Data");
            }
        });
    });
}

export const completePromises = (currentStatus, statusSelection) => {
    let promises = [];

    if (currentStatus !== statusSelection) promises.push(updateRequestStatus(statusSelection));

    const $sharedServiceComment = $('[name=SharedServicesComments]');
    const sharedServicesComment = $sharedServiceComment.val();
    if (sharedServicesComment !== '') {
        promises.push(saveSharedServicesComment(sharedServicesComment)
            .then(_ => loadCommentChain()));
    }

    return Promise.all(promises);
}

const updateRequestStatus = (status) => {
    return new Promise((resolve, reject) => {
        const data = {
            id: $('[name="Id"]').val(),
            status: status
        }
        $.post('/Operations/DownstreamContract/UpdateRequestStatus', data, function (response) {
            if (response.success) {
                resolve(response.message);
            } else {
                reject(response.message);
            }
        });
    });
};

const saveSharedServicesComment = (comment) => {
    return new Promise((resolve, reject) => {
        const data = {
            id: $('[name="Id"]').val(),
            comment: comment
        }

        $.post('/Operations/DownstreamContract/SaveSharedServicesComment', data, function (response) {
            if (response) {
                resolve("Saved Successfully");
            } else {
                reject("Error Saving Comment");
            }
        });
    });
};

const loadCommentChain = () => {
    return new Promise((resolve, reject) => {
        const data = {
            Id: $('[name="Id"]').val()
        };
        $('.js-shared-services-comment-chain').load('/Operations/DownstreamContract/SharedServiceCommentChain', data, () => {
            $('[name=SharedServicesComments]').val('');
            resolve();
        })
    })
}

